(function () {
  var params = new URLSearchParams(window.location.search);
  var testMode = params.get('dc_bubbles_test') === '1';
  var resetMode = params.get('dc_bubbles_reset') === '1';
  var storageKey = 'dcSiteBubblesSeen';
  var bubbleColor = '251,187,202';
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function storage() {
    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  }

  function isExcludedPage() {
    var path = window.location.pathname.toLowerCase();
    return (
      path.indexOf('/pages/diet-coke') !== -1 ||
      path.indexOf('/pages/may-25') !== -1 ||
      document.querySelector('.lp-diet-coke__hero, .dc-hero')
    );
  }

  function shouldRun() {
    var session = storage();
    if (resetMode && session) session.removeItem(storageKey);
    if (isExcludedPage()) return false;
    if (prefersReducedMotion && !testMode) return false;
    if (testMode) return true;
    if (session && session.getItem(storageKey) === '1') return false;
    if (session) session.setItem(storageKey, '1');
    return true;
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function initTicker(root) {
    var scope = root || document;
    var tracks = scope.querySelectorAll('[data-lp-diet-coke-ticker-track]');

    tracks.forEach(function (track) {
      var wrap = track.closest('.lp-diet-coke__ticker-wrap');
      var sourceGroup = track._lpDietCokeSourceGroup || track.querySelector('[data-lp-diet-coke-ticker-group]');
      if (!wrap || !sourceGroup) return;

      track._lpDietCokeSourceGroup = sourceGroup.cloneNode(true);

      function rebuildTicker() {
        var baseGroup = track._lpDietCokeSourceGroup.cloneNode(true);
        track.innerHTML = '';
        track.appendChild(baseGroup);

        var groupWidth = baseGroup.scrollWidth;
        var wrapWidth = wrap.clientWidth;
        if (!groupWidth || !wrapWidth) return;

        var groupCount = Math.max(2, Math.ceil((wrapWidth + groupWidth) / groupWidth) + 1);
        for (var i = 1; i < groupCount; i += 1) {
          var clone = track._lpDietCokeSourceGroup.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        }

        track.style.setProperty('--lp-diet-coke-ticker-distance', groupWidth + 'px');
        track.style.setProperty('--lp-diet-coke-ticker-duration', Math.max(18, groupWidth / 54) + 's');
      }

      rebuildTicker();

      if (track._lpDietCokeTickerReady === 'true') return;
      track._lpDietCokeTickerReady = 'true';

      var resizeTimer;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(rebuildTicker, 150);
      }, { passive: true });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(rebuildTicker).catch(function () {});
      }
    });
  }

  function initBubbles() {
    if (!shouldRun()) return;

    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    canvas.className = 'dc-site-bubbles-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);

    var bubbles = [];
    var startedAt = Date.now();
    var duration = testMode ? 30000 : 22000;
    var fadeOutMs = 900;
    var resizeTimer;

    function resize() {
      var ratio = window.devicePixelRatio || 1;
      var width = window.innerWidth || document.documentElement.clientWidth || 1440;
      var height = window.innerHeight || document.documentElement.clientHeight || 900;
      canvas.width = Math.max(1, Math.floor(width * ratio));
      canvas.height = Math.max(1, Math.floor(height * ratio));
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    }

    function makeBubble(initial) {
      var width = canvas.clientWidth || 1440;
      var height = canvas.clientHeight || 900;
      return {
        x: Math.random() * width,
        y: initial ? Math.random() * height : height + Math.random() * 60,
        r: Math.random() * 4.4 + 2.4,
        speed: Math.random() * 0.42 + 0.18,
        alpha: Math.random() * 0.2 + 0.26,
        wobble: Math.random() * Math.PI * 2,
        wobbleSpeed: (Math.random() - 0.5) * 0.026
      };
    }

    function buildBubbles() {
      var width = window.innerWidth || 1440;
      var count = width < 750 ? 58 : 104;
      bubbles = [];
      for (var i = 0; i < count; i += 1) {
        bubbles.push(makeBubble(true));
      }
    }

    function draw() {
      var width = canvas.clientWidth;
      var height = canvas.clientHeight;
      var elapsed = Date.now() - startedAt;
      var ending = elapsed > duration - fadeOutMs;
      var fade = ending ? Math.max(0, (duration - elapsed) / fadeOutMs) : 1;

      ctx.clearRect(0, 0, width, height);

      bubbles.forEach(function (bubble) {
        bubble.y -= bubble.speed;
        bubble.wobble += bubble.wobbleSpeed;
        bubble.x += Math.sin(bubble.wobble) * 0.22;

        if (bubble.y < -14) {
          Object.assign(bubble, makeBubble(false));
        }

        ctx.beginPath();
        ctx.arc(bubble.x, bubble.y, bubble.r, 0, Math.PI * 2);
        ctx.shadowColor = 'rgba(' + bubbleColor + ',' + (bubble.alpha * 0.45 * fade) + ')';
        ctx.shadowBlur = 5;
        ctx.strokeStyle = 'rgba(' + bubbleColor + ',' + (bubble.alpha * 0.95 * fade) + ')';
        ctx.lineWidth = 1.05;
        ctx.stroke();
        ctx.fillStyle = 'rgba(' + bubbleColor + ',' + (bubble.alpha * 0.2 * fade) + ')';
        ctx.fill();
        ctx.shadowBlur = 0;
      });

      if (elapsed < duration) {
        window.requestAnimationFrame(draw);
      } else {
        canvas.classList.remove('is-active');
        window.setTimeout(function () {
          canvas.remove();
        }, 450);
      }
    }

    resize();
    buildBubbles();
    window.requestAnimationFrame(function () {
      canvas.classList.add('is-active');
      draw();
    });

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        resize();
        buildBubbles();
      }, 140);
    }, { passive: true });
  }

  ready(function () {
    initTicker(document);
    initBubbles();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initTicker(event.target);
  });
})();
